import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import PlayerType, { INIT_PLAYER } from "../../models/player";

// Define a type for the slice state
export interface UserState {
  isLoggedIn: boolean;
  hasRoomAssigned: boolean;
  roomId: string;
  isUsernameUnique: boolean;
  player: PlayerType;
}

// Define the initial state using that type
const initialState: UserState = {
  isLoggedIn: false,
  hasRoomAssigned: false,
  roomId: "",
  isUsernameUnique: true,
  player: INIT_PLAYER,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // Immer takes care of the immutable state inside createSlice()
    login: (state) => {
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.isLoggedIn = false;
    },
    assignRoom: (state) => {
      state.hasRoomAssigned = true;
    },
    removeRoom: (state) => {
      state.hasRoomAssigned = false;
    },
    assignRoomId: (state, action: PayloadAction<string>) => {
      state.roomId = action.payload;
    },
    removeRoomId: (state) => {
      state.roomId = "";
    },
    userNameIsUnique: (state) => {
      state.isUsernameUnique = true;
    },
    userNameIsNotUnique: (state) => {
      state.isUsernameUnique = false;
    },
    setPlayer: (state, action: PayloadAction<PlayerType>) => {
      state.player = action.payload;
    },
  },
});

export const {
  login,
  logout,
  assignRoom,
  removeRoom,
  assignRoomId,
  removeRoomId,
  userNameIsUnique,
  userNameIsNotUnique,
  setPlayer,
} = userSlice.actions;

export default userSlice.reducer;
